import { connect } from 'react-redux';

import RatingCard from '../components/ratingCard/RatingCard';

const _mapStateToProps = ({ currentApp }) => ({
    appName: currentApp && currentApp.name,
});

export default connect(_mapStateToProps)(RatingCard);
